<template>
  <div>
    <!--change initial asset form -->
    <div>
      <div class="flex flex-col items-center justify-center mt-2">
        <div class="px-10 flex flex-col items-center justify-center">
          <p class="text-sm font-normal text-fg-muted mt-5 mb-2">
            Scan address to make deposit
          </p>
          <qrcode-vue :value="walletAddress" :size="250" level="H" />
        </div>
        <!-- address -->
        <div
          class="text-xs font-normal text-light flex flex-col items-center justify-center px-5 py-2.5 mt-5 rounded-lg shadow-xs bg-muted w-11/12 lg:w-7/12 mx-auto"
        >
          <p class="text-10px">Deposit Address</p>
          <div class="flex items-center justify-between gap-x-2">
            <p class="text-root-2 font-semibold">
              {{ maskWalletAddress(walletAddress) }}
            </p>
            <div
              class="cursor-pointer mb-1 ml-2"
              v-clipboard:copy="walletAddress"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError"
            >
              <copy-icon />
            </div>
          </div>
        </div>
      </div>
      <!-- note -->
      <div class="flex items-center justify-center mt-5">
        <div
          class="flex items-center justify-center gap-x-4 px-3 py-2 rounded-md border border-red-2 bg-pink-1"
        >
          <warning-icon-2 size="h-6 w-6" color="#DF1642" />
          <p class="text-red-1 text-xs font-light">
            Only send {{ country.currencyFull }} to this address
          </p>
        </div>
      </div>
      <!--transfer complete -->
      <div class="flex items-center px-2 lg:px-6 mb-8 mt-10">
        <el-button
          @click="$emit('goToEnterAmount')"
          class="text-primary border-primary text-sm bg-transparent rounded-lg shadow-sm lg:py-4 py-3.5 w-full"
          >Transfer Later</el-button
        >
        <el-button
          @click="transferMade"
          class="bg-primary rounded-lg text-white text-sm shadow-sm lg:py-4 py-3.5 w-full"
          >Transfer Made</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import breakpoints from '@/utils/breakpoints.js'
import { STABLE_COINS } from '@/utils/constants'
import QrcodeVue from 'qrcode.vue'
import { ParseMoneyAll, MaskWalletAddress } from '@/utils/helpers'
import country from '@/mixins/getCountryDetails.js'
export default {
  name: 'DepositWallet',
  mixins: [country],
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    use: {
      type: String,
      default: () => ''
    }
  },
  data () {
    return {
      walletAddress: '',
      stableCoins: STABLE_COINS,
      assetForm: {
        asset: '',
        network: ''
      }
    }
  },
  components: {
    CopyIcon: () => import('@/assets/icons/CopyIcon.vue'),
    WarningIcon2: () => import('@/assets/icons/WarningIcon2.vue'),
    QrcodeVue
  },
  computed: {
    hasBeenDebited () {
      return this.$store.state.terminal.hasBeenDebited
    },
    modalWidth () {
      return breakpoints.lgAndUp ? '27%' : breakpoints.mdAndUp ? '70%' : '90%'
    },
    transferDetails () {
      return (
        this.$store.state.terminal.transferTerminalDetails.transferDetails || {}
      )
    },
    isExternalApi () {
      return this.use === 'externalApi'
    }
  },
  methods: {
    parseMoneyAll (amount, currency) {
      return ParseMoneyAll(amount, currency)
    },
    onCopy: function (e) {
      this.$notify.success({
        title: 'Copied'
      })
    },
    onError: function (e) {
      this.$notify.error('Error copying to clipboard!')
    },
    maskWalletAddress (walletAddress) {
      return MaskWalletAddress(walletAddress)
    },
    transferMade () {
      this.$emit('setView', 'confirm-deposit')
    },
    getWalletAddress () {
      const vm = this
      if (this.$store.state.transactions.walletAddresses.items) {
        const walletId =
          this.$store.state.transactions.walletAddresses.items.find(
            (wallet) =>
              wallet.asset === this.country.currency &&
              wallet.reason === 'transfer'
          )
        if (walletId) {
          this.walletAddress = walletId.walletAddress
          return walletId.walletAddress
        } else {
          vm.$message({
            showClose: true,
            message: `You do not have a wallet address for ${this.country.currency}`,
            type: 'info',
            duration: 6000
          })
        }
      } else {
        vm.$message({
          showClose: true,
          message:
            'Your account is awaiting further verification. Once that is done the disabled payment method would be enabled.',
          type: 'info',
          duration: 6000
        })
      }
    },
    changeAsset (asset) {
      this.$store.dispatch('common/setActiveCountry', asset)
    }
  },
  mounted () {
    this.assetForm.network = this.country.network
    this.assetForm.asset = this.country.name
    this.getWalletAddress()
  }
}
</script>
